module.exports = __webpack_public_path__ + "img/theBusLic.352a9a53.png";